import React from "react";

import mood1 from "../../assets/images/moods/ic_sad.png";
import mood2 from "../../assets/images/moods/ic_unhappy.png";
import mood3 from "../../assets/images/moods/ic_okay.png";
import mood4 from "../../assets/images/moods/ic_happy.png";
import mood5 from "../../assets/images/moods/ic_elated.png";

const MOODS = [
  { id: "sad", label: "Sad", img: mood1 },
  { id: "unhappy", label: "Unhappy", img: mood2 },
  { id: "okay", label: "Okay", img: mood3 },
  { id: "happy", label: "Happy", img: mood4 },
  { id: "elated", label: "Elated", img: mood5 },
];

const MoodSelector = ({ value, onChange, disabled = false }) => {
  return (
    <div className="flex justify-center gap-6">
      {MOODS.map((mood) => {
        const active = value === mood.id;

        return (
          <button
            key={mood.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange?.(mood.id)}
            className={`group flex flex-col items-center transition
              ${disabled ? "cursor-default" : "cursor-pointer"}
            `}
          >
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center transition
                ${
                  active
                    ? "border-mpPurple ring-2 ring-mpPurple"
                    : "border-slate-200 group-hover:border-slate-400"
                }`}
            >
              <img
                src={mood.img}
                alt={mood.label}
                className="w-10 h-10 object-contain"
              />
            </div>

            <span
              className={`mt-2 text-sm font-medium
                ${active ? "text-mpPurple" : "text-slate-500"}`}
            >
              {mood.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default MoodSelector;
